<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 pa-0 text-xs-left text-sm-right px-1>
          <div class="font-weight-thin">
            <span @click="downloadAcamCsv" class="nowrap subtitle rounded-chip mr-3">
              CSV ACAM
            </span>
            <span @click="downloadBankTransactionsCsv" class="nowrap subtitle rounded-chip mr-3">
              CSV Transações
            </span>
            Registros: {{config.records.length}}
          </div>
        </v-flex>

        <transaction :record="record" v-for="record in config.records" :key="record.id" @refund-success="removeTransaction"/>

        <form-dialog @onCreate="onCreate" :dialog="dialog" @closeDialog="closeDialog" :autocomplete="autocomplete" />
        <v-btn color="#0e9e98de" dark small absolute top right fab @click.stop="dialog = true">
          <v-icon>add</v-icon>
        </v-btn>
        <v-flex xs12 pa-0 text-xs-left text-sm-right pa-2>
          Registros: {{config.records.length}}
        </v-flex>
    </v-layout>
    <v-snackbar v-model="showSuccessSnackbar" :timeout="3000" color="#27DABC" class="custom-snackbar">
      {{ successMessage }}
    </v-snackbar>
    </v-container>
    <v-card-actions>
      <v-layout v-if="showMoreBtn">
        <v-flex xs12 style="display: flex">
          <v-btn dark class="ma-3 btn-style"
            style="flex-shrink: 0;flex-grow: 1"
            @click="requestMoreRecords(showMoreItems)">
            EXIBIR MAIS
          </v-btn>
          <v-select
            box
            class="ma-3"
            style="flex-grow: 0;flex-shrink: 1"
            label="Quantidade"
            v-model="showMoreItems"
            :items="[100, 300, 600, 900, 1200, 1500]"
          ></v-select>
          <v-btn v-if="config.selectable" block dark class="ma-0 btn-style--secondary mt-2" @click="selectableBtnClick" >
            {{config.selectable.btn_title}}
          </v-btn>
          <v-btn v-if="config.actionable" block dark class="ma-0 btn-style--tertiary mt-2" @click="actionableBtnClick" >
            {{config.actionable.btn_title}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
<script>

import BankTransactionItem from "./BankTransactionItem"
import BankTransactionAddFormDialog from "./BankTransactionAddFormDialog"
import utils from "./shared/Utils"

export default {
  name: 'BankTransactionList',
  components: {
    'transaction': BankTransactionItem,
    'form-dialog': BankTransactionAddFormDialog,
  },
  props: {
    config: {
      type: Object
    }
  },
  data() {
    return {
      filter: '',
      lastId: null,
      dialog: false,
      showMoreItems: 100,
      showSuccessSnackbar: false,
      successMessage: "",
      autocomplete: {
        value: '0',
        source_document_type: 'cpf',
        source_document_number: '',
        bank_account: null,
        bank_account_id: null
      }
    }
  },
  mounted() {
    this.autocomplete.bank_account_id = this.$root.store.bank_transaction_last_bank_account_id

    this.$root.$on('bank_transaction_last_bank_account_id', (id) => {
      this.autocomplete.bank_account_id = id
    })
  },
  computed: {
    showMoreBtn(lim) {
      return ((this.config.records.length > 0) && (this.config.records.length % 100 == 0))
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false
    },
    getLastRecordId() {
      let lastId = this.config.records.length - 1
      return this.config.records[lastId]['id']
    },
    requestMoreRecords(e) {
      if (this.config.loading == false) {
        this.$emit('loadMoreRecords', [this.getLastRecordId(), e])
      }
    },
    selectableBtnClick() {
      this.config.selectable.btn_action()
    },
    actionableBtnClick() {
      this.config.actionable.btn_action()
    },
    onCreate(created_record) {
      this.config.records.unshift(created_record)
      this.$set(this.config, 'records', this.config.records)
    },
    removeTransaction(record) {
      const index = this.config.records.findIndex(item => item.id === record.id);

      if (index !== -1) {
        this.config.records.splice(index, 1);
      }

      this.successMessage = `Estorno da transação ID ${record.id} realizado com sucesso!`;
      this.showSuccessSnackbar = true;
    },
    downloadBankTransactionsCsv() {
      const parseDocument = (document_type, document_number) => {
        return utils.mask(document_type, document_number);
      };

      const header_line = [
        'DATE_IDENTIFICATION',
        'DATE_TRANSACTION',
        'ID',
        'PERSON_ID',
        'DOCUMENT',
        'NAME',
        'CURRENCY',
        'VALUE',
        'EXCHANGE_CURRENCY',
        'EXCHANGED_VALUE',
        'EXCHANGE_ID',
        'EXCHANGE_RATE',
        'WIRE_ID',
        'PARTNER_NAME',
        'BANK_TRANSACTION_ID',
        'BANK_TRANSACTION_SOURCE_DOCUMENT_TYPE',
        'BANK_TRANSACTION_SOURCE_DOCUMENT_NUMBER',
        'BANK_TRANSACTION_SOURCE_NAME',
        'BANK_TRANSACTION_SOURCE_ACCOUNT',
        'BANK_TRANSACTION_SOURCE_BANK',
        'BANK_TRANSACTION_SOURCE_BRANCH',
        'BANK_TRANSACTION_SOURCE_TYPE',
        'BANK_TRANSACTION_SOURCE_BANK_ISPB',
        'BANK_TRANSACTION_BANK_ACCOUNT_ID',
        'BANK_TRANSACTION_BANK_ACCOUNT_ACCOUNT',
        'BANK_TRANSACTION_BANK_ACCOUNT_BANK'
      ];

      const rows = this.config.records.reduce((rows, bankTransaction) => {
        const scheduled = bankTransaction.scheduled_bank_transaction || {};
        const subject = scheduled.subject || {};
        const company = scheduled.company || {};
        const bankAccount = bankTransaction.bank_account || {};
        const bankAccountBank = bankAccount.bank || {};

        const row = [
          utils.dbDateTimeToHuman(bankTransaction.inserted_at),
          scheduled.inserted_at ? utils.dbDateTimeToHuman(scheduled.inserted_at) : '',
          bankTransaction.scheduled_bank_transaction_id,
          subject.id || '',
          parseDocument(subject.document_type, subject.document_number),
          utils.parseCommaField(subject.social_name) || '',
          bankTransaction.currency || '',
          bankTransaction.value || '',
          bankTransaction.exchange_currency || '',
          bankTransaction.exchanged_value || '',
          bankTransaction.exchange_id || '',
          bankTransaction.exchange_rate || '',
          bankTransaction.wire_id || '',
          utils.parseCommaField(company.social_name) || '',
          bankTransaction.id || '',
          bankTransaction.source_document_type || '',
          utils.parseCommaField(bankTransaction.source_document_number) || '',
          utils.parseCommaField(bankTransaction.source_name) || '',
          utils.formatLargeNumberAsText(bankTransaction.source_account) || '',
          bankTransaction.source_bank || '',
          bankTransaction.source_branch || '',
          bankTransaction.source_type || '',
          bankTransaction.source_bank_ispb || '',
          bankAccount.id || '',
          utils.formatLargeNumberAsText(bankAccount.account_number) || '',
          utils.parseCommaField(bankAccountBank.name) || ''
        ];

        rows.push(row);
        return rows;
      }, [header_line]);

      utils.exportToCsv('transactions_report.csv', rows, ';');
    },
    downloadAcamCsv() {
      const getCompanyType = (document_number) => {
        if (!document_number) return '';
        return document_number.length > 11 ? 'J' : 'F';
      };

      const header_line = [
        'Data da Operação',
        'Tipo de cliente no Brasil',
        'CPF/CNPJ do cliente no Brasil',
        'Nome do cliente no Brasil',
        'Nome do comprador ou vendedor no exterior',
        'Pais do comprador ou vendedor no exterior',
        'Moeda',
        'Tipo da transacao',
        'Forma de pagamento',
        'Valor na moeda estrangeira',
        'Valor na moeda nacional'
      ];

      const rows = this.config.records.reduce((rows, bankTransaction) => {
        if (bankTransaction.currency === 'BRL') {
          const scheduled = bankTransaction.scheduled_bank_transaction || {};
          const company = scheduled.company || {};

          const row = [
            utils.dbDateTimeToHumanDate(bankTransaction.inserted_at),
            getCompanyType(bankTransaction.source_document_number),
            utils.parseCommaField(bankTransaction.source_document_number) || '',
            utils.parseCommaField(bankTransaction.source_name) || '',
            utils.parseCommaField(company.social_name) || '',
            company.fiscal_country || '',
            bankTransaction.exchange_currency,
            scheduled.subject_is_receiver ? '1' : '2',
            '2',
            Number(bankTransaction.exchanged_value).toFixed(2).replace('.', ','),
            Number(bankTransaction.value).toFixed(2).replace('.', ',')
          ];

          rows.push(row);
        }
        return rows;
      }, [header_line]);

      utils.exportToCsv('transactions_report_acam.csv', rows, ';');
    }
  }
}
</script>
<style>
  .search-filter .v-icon {
    color: #CCC!important;
  }
  .search-filter .v-text-field__slot input {
    color: #AAA!important;
  }
  .custom-snackbar {
    max-width: 600px !important;
    width: 100%;
    left: 0;
    right: 0;
    margin: 0 auto;
    position: fixed !important;
    z-index: 9999;
    display: flex;
    justify-content: center;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/BankTransactionList.vue